// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ThreeContainer {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: #af3254;\r\n}\r\n\r\n.ThreeJsCanvas {\r\n    display: block;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
